module.exports = __webpack_public_path__ + "img/logo.fc06c26b.svg";